import QuestionImageUploadBox from './src/main.js'

export default QuestionImageUploadBox



// WEBPACK FOOTER //
// ./src/views/question-editor/components/question-image-upload-box/index.js